import { render, staticRenderFns } from "./UniformRequestItem.vue?vue&type=template&id=c130384a&scoped=true"
import script from "./UniformRequestItem.vue?vue&type=script&lang=js"
export * from "./UniformRequestItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130384a",
  null
  
)

export default component.exports